(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-recommendations"]) return;
  try {
    
    var loadProductRecommendationsIntoSection = function() {
        if ($('.product-recommendations') === null) { return; }
        var productId = $('.product-recommendations').data('productId');
        var baseUrl = $('.product-recommendations').data('baseUrl');
        var limit = $('.product-recommendations').data('limit');
        var requestUrl = baseUrl + '?section_id=cart-recommendations&product_id=' + productId + '&limit=' + limit;
        $.ajax({
            url: requestUrl,
            method: 'GET',
            dataType: 'html',
            data: '',
            success : function(result) {
                $('.product-recommendations').html(result);
                $('body').trigger('recommendations:rendered');
            }
        });
    }

    document.addEventListener("shopify:section:load", function(event) {
        if (event.detail.sectionId === "cart-recommendations") {
            loadProductRecommendationsIntoSection();
        }
    });
   
    // Fetching the recommendations on page load
    loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
    var loadProductRecommendationsIntoSection = function() {
        if ($('.product-recommendations') === null) { return; }
        var productId = $('.product-recommendations').data('productId');
        var baseUrl = $('.product-recommendations').data('baseUrl');
        var limit = $('.product-recommendations').data('limit');
        var requestUrl = baseUrl + '?section_id=product-recommendations&product_id=' + productId + '&limit=' + limit;
        $.ajax({
            url: requestUrl,
            method: 'GET',
            dataType: 'html',
            data: '',
            success : function(result) {
                $('.product-recommendations').html(result);
                $('body').trigger('recommendations:rendered');
            }
        });
    }

    document.addEventListener("shopify:section:load", function(event) {
        if (event.detail.sectionId === "product-recommendations") {
            loadProductRecommendationsIntoSection();
        }
    });
   
    // Fetching the recommendations on page load
    loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
